export default "__VITE_ASSET__Ee04iKuK__"